import { PureComponent } from 'react';
import { downloadLog, workerClear } from '../../actions';

import { List } from 'immutable';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import {
  makeSelectDownloadingLogKeys,
  makeSelectMessagesWorker,
} from '../../selectors';
import Terminal from './Terminal';

class Tasker extends PureComponent {
  static propTypes = {
    msg: PropTypes.object.isRequired,
    worker: PropTypes.instanceOf(List),
    onWorkerClear: PropTypes.func.isRequired,
    onDownloadLog: PropTypes.func.isRequired,
    downloadingLogKeys: ImmutablePropTypes.list.isRequired,
  };

  render() {
    const { msg, onWorkerClear, worker, onDownloadLog, downloadingLogKeys } =
      this.props;
    return (
      <Terminal
        btnClearTitle={msg.btnClearTitle}
        defaultCountRows={20}
        divClass='col-xl-6 col-xs-12'
        downloadLogKey='worker'
        heightPx={250}
        label={msg.worker}
        messagesList={worker}
        msg={msg}
        onClear={onWorkerClear}
        onDownloadLog={onDownloadLog}
        downloading={downloadingLogKeys.includes('worker')}
      />
    );
  }
}

const mapStateToProps = createStructuredSelector({
  worker: makeSelectMessagesWorker(),
  downloadingLogKeys: makeSelectDownloadingLogKeys(),
});

function mapDispatchToProps(dispatch) {
  return {
    onDownloadLog: (args) => dispatch(downloadLog(args)),
    onWorkerClear: () => dispatch(workerClear()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Tasker);
